export function canLinkToEvent(offer) {
  if (!offer) return false;

  return [1, 2, 3].includes(offer.ui_version) && !offer.has_calendar_event;
}

export default canLinkToEvent;
